module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.e659b32f.svg";